import { css } from '@emotion/css';

import { CONTEXT25_COLORS } from './constants/context25-campaign';

export const bannerStyle = (isVisible: boolean): string => css`
  width: 100%;
  min-height: 42px;
  margin: 0 0 6px 0;
  padding: 5px 40px;
  background: linear-gradient(90deg, #4e763f 0%, #20432f 50%, #395e38 100%);
  border-radius: 8px;
  display: ${isVisible ? 'flex' : 'none'};
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  position: relative;
  box-sizing: border-box;
`;

export const contentStyle = css`
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
  z-index: 1;

  @media (max-width: 780px) {
    gap: 12px;
  }
`;

export const messageStyle = css`
  &&& {
    color: ${CONTEXT25_COLORS.textAndIcons};
    font-size: 14px;
    font-family: 'Lora', Georgia, 'Times New Roman', serif;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 6px;
    flex: 1;
  }

  &&& span {
    font-family: 'Lora', Georgia, 'Times New Roman', serif;
    font-weight: 500;
  }
`;

export const buttonStyle = css`
  padding: 10px 14px;
  border-radius: 9999px;
  border: none;
  background: ${CONTEXT25_COLORS.textAndIcons};
  color: ${CONTEXT25_COLORS.buttonText};
  font-family:
    'Fustat',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    'Helvetica Neue',
    Arial,
    sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 22px;

  &:hover {
    background: ${CONTEXT25_COLORS.textAndIcons};
    color: ${CONTEXT25_COLORS.buttonText};
  }

  &:focus-visible {
    outline: 2px solid ${CONTEXT25_COLORS.textAndIcons};
    outline-offset: 2px;
  }
`;

export const closeStyle = css`
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  min-height: 28px;

  &:hover {
    opacity: 0.7;
  }

  &:focus-visible {
    outline: 2px solid ${CONTEXT25_COLORS.textAndIcons};
    border-radius: 4px;
    outline-offset: 2px;
  }
`;
